import { LockIcon } from 'lucide-react'

import { TextLink } from 'slab'

export function TrustFooter () {
  return (
    <div className='mt-10 text-left flex items-start'>
      <LockIcon size={20} className='text-gray-500 mr-2 shrink-0' />
      <p className='text-gray-500 text-left'>
        Thatch does not sell your data in any way, shape, or form. Our SOC 2
        Type II certification means the data you share with Thatch is
        protected and secure. Learn more at our{' '}
        <TextLink
          href='https://trust.thatch.com/'
          target='_blank'
          rel='noopener noreferrer'
        >
          Trust Center.
        </TextLink>
      </p>
    </div>
  )
}
